import React from "react";
import "./PrivacyPolicy.css";
import { Helmet } from "react-helmet";

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div className="privacy-container">
        <div className="privacy-content">
          <h1 className="privacy-title">Privacy Policy for SART WITH K</h1>
          <p className="effective-date" style={{ fontWeight: "bold", marginBottom: "20px" }}>
            Effective Date: January 2, 2026
          </p>

          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>SART WITH K operates the mobile application SART WITH K. Your privacy is important to us, and we are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and share your information when you use our App.</p>
          </section>

          <section className="privacy-section">
            <h2>2. Information We Collect</h2>
            <p>
              When you use our App, we may collect personal information such as your name, email address, shipping address, and phone number. <strong>You may also choose to provide your date of birth on a voluntary basis to access specialized membership features.</strong>
            </p>
          </section>

          <section className="privacy-section">
            <h2>3. Purpose of Data Collection</h2>
            <p>We collect your information for the following purposes:</p>
            <ul>
              <li>
                <strong>Order Fulfillment:</strong> Processing orders and facilitating transactions.
              </li>
              <li>
                <strong>User Identification:</strong> Personalizing your shopping experience and providing customer support.
              </li>
              <li>
                <strong>In-App Membership Card (Optional Feature):</strong> If you choose to provide your date of birth, the app will automatically generate a unique digital membership card. This information is only required if you wish to participate in our loyalty program.
              </li>
              <li>
                <strong>Promotional Rewards (Optional Feature):</strong> Your birth date is used to verify eligibility for our <strong>Birthday Discount Promotions</strong>. To ensure the integrity of these rewards and prevent promotional fraud, once a date of birth is voluntarily provided, it is considered permanent and cannot be modified within the app. Users who choose not to provide this information will still have access to the app's core shopping features but will not be eligible for birthday-specific rewards.
              </li>
              <li>
                <strong>Communications:</strong> Sending promotional emails, updates, and improving app performance.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Sharing Your Information</h2>
            <p>To achieve these purposes, we may share your information with third parties. This includes payment processors who handle transactions, shipping companies that fulfill orders, and analytics providers that help us track and improve app performance. We will not sell, rent, or lease your personal information to third parties without your consent.</p>
          </section>

          <section className="privacy-section">
            <h2>5. Data Storage and Security</h2>
            <p>We take the security of your personal information seriously. Your data is stored on encrypted servers and third-party cloud services (e.g., AWS, Google Cloud).</p>
            <p>We use encryption during transmission and at rest, and access to your data is restricted to authorized personnel only.</p>
            <p>
              <strong>Note:</strong> As specified in Section 3, certain identity-verifying data such as the Date of Birth is locked once submitted to maintain the security of our membership and discount systems.
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. User Rights</h2>
            <p>You have certain rights regarding your personal information. You can:</p>
            <ul>
              <li>Access and update your profile data (excluding birth date) via your account settings.</li>
              <li>Request the deletion of your account and associated data.</li>
              <li>Opt out of marketing communications.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>7. Tracking Technologies</h2>
            <p>We may use tracking technologies such as Google Analytics to collect information about usage data. This helps us understand how users interact with our App and improve the user experience.</p>
          </section>

          <section className="privacy-section">
            <h2>8. Children's Privacy</h2>
            <p>Our App is not intended for children under 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take steps to delete it.</p>
          </section>

          <section className="privacy-section">
            <h2>9. Location of Operations</h2>
            <p>Our App is primarily used in Cambodia, and we comply with local regulations regarding data protection and privacy.</p>
          </section>

          <section className="privacy-section">
            <h2>10. Contact Us</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy, please contact us at
              <a href="mailto:sartwithk@gmail.com"> sartwithk@gmail.com</a>.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Changes to This Privacy Policy</h2>
            <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the effective date.</p>
          </section>
        </div>
      </div>
    </>
  );
}
